import React from 'react'
import img2024 from '../components/images/jiomart.jpg'
const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2024} alt='jiomart' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>Maximize Your JioMart Potential with E Seller Support
                    </h2>
                    <p>As a trusted partner of JioMart, E Seller Support has unique features to provide you with unparalleled expertise and support in maintaining your JioMart storefront. Our comprehensive range of services, from account management to custom product development, ensures that your business maximizes its potential in one of India’s fastest growing online markets. With our in-depth expertise and JioMart-supported solutions, we empower you to navigate the challenges of selling on JioMart more effectively and efficiently, thereby taking your success to new heights. Rely on e retailer support to deliver what it takes to excel in a competitive eCommerce environment. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
        </>
    )
}

export default events